import { useState } from 'react';

export const useModal = () => {
  const [open, setOpen] = useState(false);

  const handleChange = () => {
    setOpen((prev) => !prev);
  };

  return { open, handleChange };
};
